module.exports = __webpack_public_path__ + "static/media/banner.4cae161d.png";